import { render, staticRenderFns } from "./ListEmailTemplateTable.vue?vue&type=template&id=2185ff26&"
import script from "./ListEmailTemplateTable.vue?vue&type=script&lang=js&"
export * from "./ListEmailTemplateTable.vue?vue&type=script&lang=js&"
import style0 from "./ListEmailTemplateTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports